import React, { createContext } from 'react';

const GlobalLogOutContext = createContext<{
  globalLogOut?: string | undefined;
  setGlobalLogOut?: React.Dispatch<string | undefined>;
}>({});

export const GlobalLogOutProvider = GlobalLogOutContext.Provider;
export const GlobalLogOutConsumer = GlobalLogOutContext.Consumer;

export default GlobalLogOutContext;
